export default __webpack_public_path__ + "static/media/logout.929c4609.svg";